// extracted by mini-css-extract-plugin
export default {"overlay":"yz-z","bodyOpen":"zz-z","content":"Az-z","header":"Bz-z","close":"Cz-z","closeNoHeading":"Dz-z"};